import API from "../../../api.js";
import {
  ADMIN_DOCTORS_LIST_REQUEST,
  ADMIN_DOCTORS_LIST_SUCCESS,
  ADMIN_DOCTORS_LIST_FAIL,
  ADMIN_DOCTOR_ADD_REQUEST,
  ADMIN_DOCTOR_ADD_SUCCESS,
  ADMIN_DOCTOR_ADD_FAIL,
  ADMIN_DOCTOR_UPDATE_REQUEST,
  ADMIN_DOCTOR_UPDATE_SUCCESS,
  ADMIN_DOCTOR_UPDATE_FAIL,
  ADMIN_DOCTOR_DELETE_REQUEST,
  ADMIN_DOCTOR_DELETE_SUCCESS,
  ADMIN_DOCTOR_DELETE_FAIL,
} from "../../constants/adminConstants/doctorConstants.js";

// ✅ Get all doctors
export const listDoctors = () => async (dispatch) => {
  try {
    dispatch({ type: ADMIN_DOCTORS_LIST_REQUEST });
    const { data } = await API.get("/admin/doctors");
     console.log(data)                       
    dispatch({ type: ADMIN_DOCTORS_LIST_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: ADMIN_DOCTORS_LIST_FAIL,
      payload: error.response?.data?.msg || error.message,
    });
  }
};

// ✅ Add new doctor
export const addDoctor = (doctorData) => async (dispatch) => {
  try {
    dispatch({ type: ADMIN_DOCTOR_ADD_REQUEST });
    const { data } = await API.post("/admin/doctors", doctorData);
    dispatch({ type: ADMIN_DOCTOR_ADD_SUCCESS, payload: data });
    return data;
  } catch (error) {
    dispatch({
      type: ADMIN_DOCTOR_ADD_FAIL,
      payload: error.response?.data?.msg || error.message,
    });
    throw error;
  }
};

// ✅ Update doctor
export const updateDoctor = (id, updates) => async (dispatch) => {
  try {
    dispatch({ type: ADMIN_DOCTOR_UPDATE_REQUEST });
    const { data } = await API.put(`/admin/doctors/${id}`, updates);
    dispatch({ type: ADMIN_DOCTOR_UPDATE_SUCCESS, payload: data });
    return data;
  } catch (error) {
    dispatch({
      type: ADMIN_DOCTOR_UPDATE_FAIL,
      payload: error.response?.data?.msg || error.message,
    });
    throw error;
  }
};

// ✅ Delete doctor
export const deleteDoctor = (id) => async (dispatch) => {
  try {
    dispatch({ type: ADMIN_DOCTOR_DELETE_REQUEST });
    const { data } = await API.delete(`/admin/doctors/${id}`);
    dispatch({ type: ADMIN_DOCTOR_DELETE_SUCCESS, payload: data });
    return data;
  } catch (error) {
    dispatch({
      type: ADMIN_DOCTOR_DELETE_FAIL,
      payload: error.response?.data?.msg || error.message,
    });
    throw error;
  }
};
